// src/components/SubNav.js
import React from "react";
import { Link, useLocation } from "react-router-dom";

const SubNav = ({ items = [] }) => {
  const location = useLocation();
  const links = items.flatMap((item) =>
    item.subItems && item.subItems.length ? item.subItems : [item]
  );
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="sub-navbar" aria-label="Section navigation">
      <div className="sub-navbar-inner">
        {/* This wrapper is REQUIRED for spacing/alignment */}
        <div className="sub-navbar-content">
          {links.map((link, i) => (
            <Link
              key={`${link.path}-${i}`}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? "active" : ""}`}
            >
              {link.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default SubNav;

